import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useStoreCurrency } from "../../../../hooks/useStoreCurrency";
import { useGetJournalEntries } from "../../../../hooks/api/queries/useAccountings";
import { getUrlQuerysection } from "../../../../helpers";
import { useEffect } from "react";

const useJournalEntriesTab = ({ journalStatus }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { storeHasMultipleCurrency } = useStoreCurrency();
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const [startDate, setStartDate] = useState(searchParams.get("start_date"));
  const [endDate, setEndDate] = useState(searchParams.get("end_date"));
  const [currentStore, setCurrentStore] = useState(
    storeHasMultipleCurrency
      ? searchParams.get("store_id") || storeList?.[0]?.id
      : "",
  );
  const [sourceModule, setSourceModule] = useState(
    searchParams.get("entity_type"),
  );
  const [entryType, setEntryType] = useState(searchParams.get("entry_type"));
  const queries = getUrlQuerysection();

  const sourceModules = [
    {
      name: "All Modules",
      id: null,
    },
    {
      name: "Order Sales",
      id: "ORDER_SALES",
    },
    {
      name: "Order COGS",
      id: "ORDER_COGS",
    },
    {
      name: "Expense",
      id: "EXPENSE",
    },
    {
      name: "Returns Sales",
      id: "RETURNS_SALES",
    },
    {
      name: "Returns COGS",
      id: "RETURNS_COGS",
    },
    {
      name: "Goods Received",
      id: "GOODS_RECEIVED",
    },
    {
      name: "Invoice",
      id: "INVOICE",
    },
    {
      name: "Invoice Payment",
      id: "INVOICE_PAYMENT",
    },
    {
      name: "Customer Credit",
      id: "CUSTOMER_CREDIT",
    },
    {
      name: "Store Wallet",
      id: "STORE_WALLET",
    },
    {
      name: "Manual",
      id: "MANUAL",
    },
  ];

  const entryTypes = [
    {
      name: "All Types",
      id: null,
    },
    {
      name: "Manual",
      id: "MANUAL",
    },
    {
      name: "System Generated",
      id: "SYSTEM",
    },
    {
      name: "Imported",
      id: "IMPORTED",
    },
  ];

  const gotoPage = (pageNumber) => {
    searchParams.set("page", pageNumber);
    setSearchParams(searchParams, { replace: true });
  };

  const setDateFilter = (data) => {
    const { startDate, endDate } = data;
    searchParams.set("start_date", startDate);
    searchParams.set("end_date", endDate);
    setStartDate(startDate);
    setEndDate(endDate);
    setSearchParams(searchParams, { replace: true });
  };

  const setStoreFilter = (storeId) => {
    setCurrentStore(storeId);
    if (storeId === "ALL_STORES" || storeId === "")
      searchParams.delete("store_id");
    else searchParams.set("store_id", storeId);
    setSearchParams(searchParams, { replace: true });
  };

  const setSourceModuleFilter = (sourceModule) => {
    setSourceModule(sourceModule);
    if (!sourceModule) searchParams.delete("entity_type");
    else searchParams.set("entity_type", sourceModule);
    setSearchParams(searchParams, { replace: true });
  };

  const setEntryTypeFilter = (entryType) => {
    setEntryType(entryType);
    if (!entryType) searchParams.delete("entry_type");
    else searchParams.set("entry_type", entryType);
    setSearchParams(searchParams, { replace: true });
  };

  const {
    isLoading: isLoadingJournalEntries,
    data: journalEntries,
    refetch: handleFetchJournalEntries,
  } = useGetJournalEntries({
    queries,
    queryParams: journalStatus ? { status: journalStatus } : {},
  });

  useEffect(() => {
    handleFetchJournalEntries();
  }, [searchParams, setSearchParams]);

  return {
    isLoadingJournalEntries,
    journalEntries: journalEntries?.data || [],
    metaDetails: journalEntries?.meta || {},
    storeList,
    storeHasMultipleCurrency,
    startDate,
    endDate,
    currentStore,
    sourceModules,
    entryTypes,
    sourceModule,
    entryType,
    setDateFilter,
    setStoreFilter,
    handleFetchJournalEntries,
    gotoPage,
    setSourceModuleFilter,
    setEntryTypeFilter,
  };
};
export default useJournalEntriesTab;
